export const BAM_PLAYER_FIT = {
  EXACT_SIZE: 'exact-size',
  SAME_HEIGHT: 'same-height',
  SAME_WIDTH: 'same-width',
  FILL_PARENT: 'fill-parent',
};

export const HORIZONTAL_POSITION = {
  CENTER: 0,
  LEFT: -1,
  RIGHT: 1,
};

export const SCALE_MODE = {
  FIT: 'fit',
  FILL: 'fill',
};

export const ACTION_TYPE = {
  LINK: 'link',
};

export const PRODUCT_ACTION_TYPE = {
  NONE: 'none',
  EXPAND: 'expand',
  EXPAND_PRODUCT: 'expand-product',
  MODAL: 'modal',
  DRAWER: 'drawer',
  TAB_CURRENT: 'tab-current',
  TAB_NEW: 'tab-new',
};

export const BAM_PRODUCT_MODE = {
  INLINE: 'inline',
  DRAWER: 'drawer',
  MODAL: 'modal',
};

export const CLOSED_CAPTIONS_MODE = {
  OFF: 'off',
  ORIGINAL: 'original',
};

// Valid closed captions language codes (mirrored from player CC_LOCALES).
// If this list changes, it should also be updated in:
// - player/src/constants.js (CC_LOCALES)
// - dashboard/src/constants/locales.js (CC_LOCALES)
// - vod/src/config/locales.ts (CC_LOCALES)
// - functions/lib/constants/locales.js (CC_LOCALES)
export const CC_LOCALES = new Set([
  'ab-GE', 'af-ZA', 'ar-AE', 'ar-SA', 'ast-ES', 'az-AZ', 'ba-RU', 'be-BY',
  'bg-BG', 'bn-IN', 'bs-BA', 'ca-ES', 'ckb-IQ', 'ckb-IR', 'cs-CZ', 'cy-WL',
  'da-DK', 'de-CH', 'de-DE', 'el-GR', 'en-AB', 'en-AU', 'en-CA', 'en-GB',
  'en-IE', 'en-IN', 'en-NZ', 'en-US', 'en-WL', 'en-ZA', 'es-ES', 'es-US',
  'et-ET', 'eu-ES', 'fa-IR', 'fi-FI', 'fr-CA', 'fr-FR', 'gl-ES', 'gu-IN',
  'ha-NG', 'he-IL', 'hi-IN', 'hr-HR', 'hu-HU', 'hy-AM', 'id-ID', 'is-IS',
  'it-IT', 'ja-JP', 'ka-GE', 'kab-DZ', 'kk-KZ', 'kn-IN', 'ko-KR', 'ky-KG',
  'lg-IN', 'lt-LT', 'lv-LV', 'mhr-RU', 'mk-MK', 'ml-IN', 'mn-MN', 'mr-IN',
  'ms-MY', 'mt-MT', 'nl-NL', 'no-NO', 'or-IN', 'pa-IN', 'pl-PL', 'ps-AF',
  'pt-BR', 'pt-PT', 'ro-RO', 'ru-RU', 'rw-RW', 'si-LK', 'sk-SK', 'sl-SI',
  'so-SO', 'sr-RS', 'su-ID', 'sv-SE', 'sw-BI', 'sw-KE', 'sw-RW', 'sw-TZ',
  'sw-UG', 'ta-IN', 'te-IN', 'th-TH', 'tl-PH', 'tr-TR', 'tt-RU', 'ug-CN',
  'uk-UA', 'uz-UZ', 'vi-VN', 'wo-SN', 'zh-CN', 'zh-TW', 'zu-ZA',
]);

export const FOCUS_MODE = {
  NONE: 'none',
  CAROUSEL: 'carousel',
  SINGLE: 'single',
  PLAYPAUSE: 'playpause',
};

export const NAVIGATION_MODE = {
  NONE: 'none',
  FAB: 'fab',
  FAB_MANUAL: 'fab-manual',
};

export const VIEW_STATE = {
  EXPANDED: 'expanded',
  FAB: 'fab',
  DEFAULT: 'default',
};
